import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import NodeIcon from './NodeIcon';
import { getNodeTypeInfo } from './editorUtils';
import { useNodeTypeRegistry } from './NodeTypeContext';

const getNodeIconStyle = (node) => {
  const integration = node.integration;
  const type = node.type || '';

  if (integration === 'felloh') return { bg: 'bg-violet-500', text: 'text-white' };
  if (integration === 'pipedrive') return { bg: 'bg-emerald-500', text: 'text-white' };
  if (integration === 'xero') return { bg: 'bg-cyan-400', text: 'text-white' };
  if (integration === 'email') return { bg: 'bg-rose-400', text: 'text-white' };
  if (integration === 'slack') return { bg: 'bg-violet-500', text: 'text-white' };
  if (integration === 'sage') return { bg: 'bg-green-600', text: 'text-white' };

  if (type.includes('webhook') || type.includes('trigger') || type.includes('schedule')) return { bg: 'bg-teal-500', text: 'text-white' };
  if (type.includes('if') || type.includes('filter')) return { bg: 'bg-amber-500', text: 'text-white' };
  if (type.includes('switch')) return { bg: 'bg-rose-500', text: 'text-white' };
  if (type.includes('code')) return { bg: 'bg-orange-500', text: 'text-white' };
  if (type.includes('httpRequest')) return { bg: 'bg-blue-500', text: 'text-white' };
  if (type.includes('set')) return { bg: 'bg-indigo-400', text: 'text-white' };
  if (type.includes('split')) return { bg: 'bg-pink-500', text: 'text-white' };
  if (type.includes('merge')) return { bg: 'bg-cyan-500', text: 'text-white' };
  if (type.includes('respond')) return { bg: 'bg-teal-500', text: 'text-white' };
  if (type.includes('wait')) return { bg: 'bg-gray-600', text: 'text-white' };
  if (type.includes('noOp')) return { bg: 'bg-gray-400', text: 'text-white' };
  if (type.includes('dateTime')) return { bg: 'bg-purple-500', text: 'text-white' };
  if (type.includes('itemLists') || type.includes('sort') || type.includes('limit') || type.includes('removeDuplicates')) return { bg: 'bg-indigo-500', text: 'text-white' };
  if (type.includes('aggregate')) return { bg: 'bg-indigo-600', text: 'text-white' };
  if (type.includes('xml') || type.includes('html')) return { bg: 'bg-emerald-500', text: 'text-white' };
  if (type.includes('crypto')) return { bg: 'bg-gray-700', text: 'text-white' };
  if (type.includes('emailSend')) return { bg: 'bg-rose-500', text: 'text-white' };
  if (type.includes('slack')) return { bg: 'bg-violet-500', text: 'text-white' };
  if (type.includes('manual')) return { bg: 'bg-teal-600', text: 'text-white' };
  if (type.includes('discord')) return { bg: 'bg-indigo-600', text: 'text-white' };
  if (type.includes('telegram')) return { bg: 'bg-sky-500', text: 'text-white' };
  if (type.includes('teams') || type.includes('Teams')) return { bg: 'bg-violet-600', text: 'text-white' };
  if (type.includes('gmail') || type.includes('outlook') || type.includes('sendGrid')) return { bg: 'bg-rose-500', text: 'text-white' };
  if (type.includes('hubspot')) return { bg: 'bg-orange-500', text: 'text-white' };
  if (type.includes('salesforce')) return { bg: 'bg-sky-600', text: 'text-white' };
  if (type.includes('pipedrive')) return { bg: 'bg-emerald-500', text: 'text-white' };
  if (type.includes('jira')) return { bg: 'bg-blue-600', text: 'text-white' };
  if (type.includes('linear')) return { bg: 'bg-violet-500', text: 'text-white' };
  if (type.includes('notion')) return { bg: 'bg-gray-800', text: 'text-white' };
  if (type.includes('trello')) return { bg: 'bg-blue-500', text: 'text-white' };
  if (type.includes('asana')) return { bg: 'bg-rose-600', text: 'text-white' };
  if (type.includes('xero')) return { bg: 'bg-cyan-500', text: 'text-white' };
  if (type.includes('quickbooks')) return { bg: 'bg-green-600', text: 'text-white' };
  if (type.includes('shopify')) return { bg: 'bg-lime-600', text: 'text-white' };
  if (type.includes('wooCommerce') || type.includes('woo')) return { bg: 'bg-purple-600', text: 'text-white' };
  if (type.includes('stripe')) return { bg: 'bg-violet-600', text: 'text-white' };
  if (type.includes('postgres')) return { bg: 'bg-blue-700', text: 'text-white' };
  if (type.includes('mysql') || type.includes('mySql')) return { bg: 'bg-orange-600', text: 'text-white' };
  if (type.includes('mongo')) return { bg: 'bg-green-700', text: 'text-white' };
  if (type.includes('redis')) return { bg: 'bg-red-600', text: 'text-white' };
  if (type.includes('googleSheets') || type.includes('Sheets')) return { bg: 'bg-green-500', text: 'text-white' };
  if (type.includes('airtable')) return { bg: 'bg-blue-500', text: 'text-white' };
  if (type.includes('s3')) return { bg: 'bg-orange-500', text: 'text-white' };
  if (type.includes('googleDrive') || type.includes('Drive')) return { bg: 'bg-yellow-500', text: 'text-white' };
  if (type.includes('github')) return { bg: 'bg-gray-800', text: 'text-white' };
  if (type.includes('gitlab')) return { bg: 'bg-orange-600', text: 'text-white' };
  if (type.includes('openAi') || type.includes('langchain')) return { bg: 'bg-emerald-600', text: 'text-white' };
  if (type.includes('twilio')) return { bg: 'bg-red-500', text: 'text-white' };
  if (type.includes('calendar') || type.includes('Calendar')) return { bg: 'bg-blue-500', text: 'text-white' };
  if (type.includes('ftp')) return { bg: 'bg-gray-600', text: 'text-white' };
  if (type.includes('cron')) return { bg: 'bg-teal-500', text: 'text-white' };

  return { bg: 'bg-gray-500', text: 'text-white' };
};

const getNodeSubtitle = (node) => {
  const type = node.type || '';
  const params = node.parameters || {};

  if (params.operation) return params.operation;
  if (type.includes('webhook')) return 'webhook';
  if (type.includes('trigger') || type.includes('schedule')) return 'trigger';
  if (type.includes('filter')) return 'filter';
  if (type.includes('if')) return 'condition';
  if (type.includes('switch')) return 'router';
  if (type.includes('code')) return 'function';
  if (type.includes('httpRequest')) return 'HTTP request';
  if (type.includes('set')) return 'set values';
  if (type.includes('split')) return 'split data';
  if (type.includes('merge')) return 'merge';
  if (type.includes('respond')) return 'respond';
  if (type.includes('wait')) return 'wait';
  if (type.includes('noOp')) return 'no-op';
  if (type.includes('dateTime')) return 'date/time';
  if (type.includes('itemLists')) return 'list operation';
  if (type.includes('aggregate')) return 'aggregate';
  if (type.includes('removeDuplicates')) return 'deduplicate';
  if (type.includes('limit')) return 'limit';
  if (type.includes('sort')) return 'sort';
  if (type.includes('xml')) return 'XML';
  if (type.includes('html')) return 'HTML';
  if (type.includes('crypto')) return 'crypto';
  if (type.includes('executeCommand')) return 'command';
  if (type.includes('emailSend')) return 'email';
  if (type.includes('slack')) return 'slack';
  if (type.includes('manual')) return 'manual trigger';
  if (type.includes('schedule')) return 'schedule';

  return type.replace('n8n-nodes-base.', '') || null;
};

const NodeTypeIcon = ({ node, className = 'w-5 h-5' }) => {
  const type = node.type || '';

  if (type.includes('webhook') || type.includes('trigger') || type.includes('schedule'))
    return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>;
  if (type.includes('code'))
    return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 18l6-6-6-6M8 6l-6 6 6 6" /></svg>;
  if (type.includes('if') || type.includes('filter'))
    return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" /></svg>;
  if (type.includes('httpRequest'))
    return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>;
  if (type.includes('set'))
    return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="9" y1="3" x2="9" y2="21" /></svg>;
  if (type.includes('switch') || type.includes('split'))
    return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5" /></svg>;
  if (type.includes('merge'))
    return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 6l4 4 4-4M12 10v8" /></svg>;
  if (type.includes('respond'))
    return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>;
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" /></svg>;
};

const isMultiOutput = (type) => (type || '').includes('if') || (type || '').includes('switch');

const EditableStepNode = memo(({ data, selected }) => {
  const node = data.node || {};
  const iconStyle = getNodeIconStyle(node);
  const subtitle = getNodeSubtitle(node);
  const multiOutput = isMultiOutput(node.type);
  const registry = useNodeTypeRegistry();

  const handleDelete = (e) => {
    e.stopPropagation();
    if (data.onDelete) data.onDelete(node.id);
  };

  return (
    <div className="flex flex-col items-center group">
      {/* Node card with handles INSIDE */}
      <div
        className={`relative bg-gray-800 rounded-lg w-[56px] h-[56px] flex items-center justify-center shadow-lg transition-all hover:shadow-xl cursor-pointer ${
          selected ? 'ring-2 ring-violet-500 ring-offset-2 ring-offset-white dark:ring-offset-gray-900' : ''
        }`}
      >
        {/* Delete button */}
        <button
          onClick={handleDelete}
          className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-sm hover:bg-red-600 z-10"
        >
          <XMarkIcon className="w-3 h-3" />
        </button>

        {/* Target handle - left side of card */}
        <Handle
          type="target"
          position={Position.Left}
          className="!bg-violet-400 !w-2.5 !h-2.5 !border-2 !border-gray-800 !-left-1 opacity-0 group-hover:opacity-100 transition-opacity"
        />

        {/* Icon */}
        <div className={`w-8 h-8 rounded-md ${iconStyle.bg} flex items-center justify-center`}>
          {(() => {
            const info = getNodeTypeInfo(node.type, registry);
            const key = info?.key || node.type?.replace('n8n-nodes-base.', '') || '';
            return <NodeIcon nodeKey={key} label={node.name} size="md" /> || <NodeTypeIcon node={node} className={`w-5 h-5 ${iconStyle.text}`} />;
          })()}
        </div>

        {/* Source handle(s) - right side of card */}
        {multiOutput ? (
          <>
            <Handle
              type="source"
              position={Position.Right}
              id="source-0"
              className="!bg-emerald-500 !w-2.5 !h-2.5 !border-2 !border-gray-800 !-right-1"
              style={{ top: '25%' }}
              title="true"
            />
            <Handle
              type="source"
              position={Position.Right}
              id="source-1"
              className="!bg-red-400 !w-2.5 !h-2.5 !border-2 !border-gray-800 !-right-1"
              style={{ top: '75%' }}
              title="false"
            />
          </>
        ) : (
          <Handle
            type="source"
            position={Position.Right}
            className="!bg-violet-400 !w-2.5 !h-2.5 !border-2 !border-gray-800 !-right-1 opacity-0 group-hover:opacity-100 transition-opacity"
          />
        )}
      </div>

      {/* Label below */}
      <div className="mt-2 text-center max-w-[120px]">
        <div className="text-xs font-medium text-gray-700 dark:text-gray-200 whitespace-nowrap overflow-hidden text-ellipsis">
          {node.name}
        </div>
        {subtitle && (
          <div className="text-[10px] text-gray-500 dark:text-gray-400">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
});

EditableStepNode.displayName = 'EditableStepNode';

export default EditableStepNode;
